const eventAttributes = {
  source_page_referrer: document.referrer,
  page_title: document.title,
  url: window.location.href,
}

amplitude.getInstance().logEvent("homepage_viewed", eventAttributes)